import { of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '@app/auth/services/token.service';
import { map, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./token.service";
export class AuthService {
    constructor(http, tokenService) {
        this.http = http;
        this.tokenService = tokenService;
        this.endpoints = {
            register: 'user/register',
            forgotPassword: 'account/forgotpassword',
            loginCheck: 'account/authenticate',
            twoFactorLogin: 'account/twofactor',
            getUser: 'user/getcurrentuser',
            resetPassword: 'account/resetpassword',
            sendTwoFactorActivationCode: 'account/activationCode',
            recoverTwoFactor: 'account/recover'
        };
    }
    register(registerUser) {
        return this.http.post(`${this.endpoints.register}`, registerUser);
    }
    forgotPasswordRequest(forgotPasswordRequest) {
        return this.http.post(`${this.endpoints.forgotPassword}`, forgotPasswordRequest);
    }
    resetPasswordRequest(resetPasswordRequest) {
        return this.http.post(`${this.endpoints.resetPassword}`, resetPasswordRequest);
    }
    login(credentials) {
        //Always clear the old token before requesting a new one
        if (this.tokenService.hasToken()) {
            this.tokenService.removeToken();
        }
        return this.http.post(this.endpoints.loginCheck, credentials, { withCredentials: true }).pipe(map((response) => {
            if (!response.isTwoFactorEnabled && response.twoFactorQrCode == null) {
                this.tokenService.setToken(response.accessToken, response.refreshToken, response.claims, response.features, response.isCustomer, response.versionNumber);
            }
            return response;
        }), catchError(() => {
            return throwError('Ongeldig e-mailadres en/of wachtwoord.');
        }));
    }
    twoFactorLogin(twoFactorRequest) {
        return this.http.post(this.endpoints.twoFactorLogin, twoFactorRequest, { withCredentials: true }).pipe(map((response) => {
            this.tokenService.setToken(response.accessToken, response.refreshToken, response.claims, response.features, response.isCustomer, response.versionNumber);
            return response;
        }), catchError(() => {
            return throwError('De authenticatie code is ongeldig.');
        }));
    }
    sendTwoFactorActivationCode(twoFactorRequest) {
        return this.http.post(this.endpoints.sendTwoFactorActivationCode, twoFactorRequest);
    }
    retrieveCurrentUser() {
        return this.http.get(this.endpoints.getUser).pipe(map(user => user));
    }
    recoverTwoFactor(code) {
        return this.http.post(this.endpoints.recoverTwoFactor, code, { withCredentials: true }).pipe(map((response) => {
            this.tokenService.setToken(response.accessToken, response.refreshToken, response.claims, response.features, response.isCustomer, response.versionNumber);
            return response;
        }), catchError(() => {
            return throwError('De herstel code is ongeldig.');
        }));
    }
    logout() {
        this.tokenService.removeToken();
        return of(true);
    }
}
AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.HttpClient), i0.inject(i2.TokenService)); }, token: AuthService, providedIn: "root" });
